import styled from 'styled-components';
import { outlineGray, textGrey, primaryColor, primaryColorWeak, disabledBackground, accentColor } from '../../../config/colors';
import { IoClose, IoArchive, IoDuplicate, IoArrowUndoSharp } from 'react-icons/io5';
import { AiFillStar } from 'react-icons/ai';
import Button from '../../Button';
import { ReactComponent as ProjectIconCmp } from '../../../resources/icons/circle-filter.svg';

export const Wrapper = styled.ul`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  li:not(:first-child) {
    margin-top: 10px;
  }
`;

export const ProjectItemWrapper = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-right: 40px;
  :hover {
      button:nth-of-type(2) {
          display: flex !important;
      }
      button:nth-of-type(3) {
          display: flex !important;
      }
  }
`;

export const ProjectWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-height: 50px;
  position: relative;
  padding: 8px;
  border: 1px solid ${outlineGray};
  background-color: ${(props) => (props.isSelected ? primaryColorWeak : props.training ? accentColor : 'transparent')};
  :hover {
    cursor: pointer;
  }
`;

export const ProjectIcon = styled(ProjectIconCmp)`
  height: 40px;
  width: 40px;
  min-width: 40px;
  margin-right: 15px;
  fill: ${primaryColor};
`;

export const ProjectInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90%;
`;

export const ProjectName = styled.h5`
  font-size: 0.813rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0;
  margin-bottom: 3px;
`;

export const ProjectInfo = styled.p`
  font-size: 0.6rem;
`;

export const DeleteProjectBtnSmall = styled(Button).attrs(({hoverText}) => ({
  wrapperStyle: {
    width: '18px',
    height: 'auto',
    padding: 2,
    position: 'absolute',
    top: '25%',
    right: 0,
    transform: 'translate(120%, -50%)',
    backgroundColor: disabledBackground,
    display: 'none',
  },
  hoverText: hoverText,
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '0.875rem',
  },
}))``;
export const ArchiveProjectBtnSmall = styled(Button).attrs(({hoverText}) => ({
  wrapperStyle: {
    width: '18px',
    height: 'auto',
    padding: 2,
    position: 'absolute',
    top: '25%',
    right: 10,
    transform: 'translate(280%, -50%)',
    backgroundColor: disabledBackground,
    display: 'none',
    zIndex: 20,
  },
  hoverText: hoverText,
  type: 'rounded',
  icon: IoArchive,
  iconProps: {
    color: 'white',
    size: '0.875rem',
  },
}))``;
export const ArchiveProjectBtn = styled(Button).attrs(({hoverText}) => ({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    padding: 2,
    position: 'absolute',
    top: '25%',
    right: 0,
    transform: 'translate(175%, -50%)',
    backgroundColor: disabledBackground,
    display: 'none',
  },
  hoverText: hoverText,
  type: 'rounded',
  icon: IoArchive,
  iconProps: {
    color: 'white',
    size: '0.875rem',
  },
}))``;
export const UnarchiveProjectBtn = styled(Button).attrs({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    padding: 2,
    position: 'absolute',
    top: '25%',
    right: 0,
    transform: 'translate(175%, -50%)',
    backgroundColor: disabledBackground,
  },
  hoverText: 'Restore',
  type: 'rounded',
  icon: IoArrowUndoSharp,
  iconProps: {
    color: 'white',
    size: '0.875rem',
  },
})``;

export const DuplicateProjectBtn = styled(Button).attrs({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    padding: 2,
    position: 'absolute',
    top: '75%',
    right: 0,
    transform: 'translate(175%, -50%)',
    backgroundColor: primaryColor,
  },
  type: 'rounded',
  icon: IoDuplicate,
  iconProps: {
    color: 'white',
    size: '0.875rem',
  },
})``;

export const StarProjectBtn = styled(Button).attrs(({ isStarred }) => ({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    position: 'absolute',
    top: 5,
    right: 5,
  },
  type: 'transparentBackgroundButton',
  icon: AiFillStar,
  iconProps: {
    color: isStarred ? 'gold' : 'transparent',
    size: '1.25rem',
    stroke: 'gainsboro',
    strokeWidth: isStarred ? 0 : '10%',
  },
}))``;

export const NoProjectText = styled.p`
  padding-top: 2rem;
  font-weight: bold;
  color: ${textGrey};
  opacity: 0.7;
  line-height: 1.6;
  text-align: center;
`;

export const ToggleTrainingWrapper = styled.div`
  margin-bottom: 1rem;
  display: flex;
  justify-content: end;
  padding-right: 40px;
`;

export const ToggleTrainingBtn = styled.div`
  cursor: pointer;
  color: ${primaryColor};
  font-size: 12px;
`;

export const ArchivedProjectsWrapper = styled.div`
`;

export const ToggleArchivedProjectsWrapper = styled.div`
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  justify-content: end;
  padding-right: 40px;
`;

export const ArchivedProjectList = styled.div`
  
`;
